import { DataLayer } from '@grandvisionhq/analytics';

const variantClickEvent = (event_type, product)=>({
        event_type,
        event: 'product_variation_click',
        event_category: product.type,
        product
    })
;
const pushEvent = (event)=>DataLayer.pushEvent(event)
;
const ProductAnalyticsEvents = {
    pushPdpVariantClickEvent: (product)=>{
        const pdpVariantClickEvent = variantClickEvent('pdp', product);
        pushEvent(pdpVariantClickEvent);
    },
    pushPlpVariantClickEvent: (product)=>{
        const plpVariantClickEvent = variantClickEvent('plp', product);
        pushEvent(plpVariantClickEvent);
    }
};

export { ProductAnalyticsEvents };
//# sourceMappingURL=ProductAnalyticsEvents.js.map
